import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-async-promise-order',
  slug: 'promise-order',
  title: 'Inside the event loop',
  type: 'predict',
  estSeconds: 90,
  contentVersion: 1,
});
